// Generated from src/assets/Check.svg
import React, { PureComponent } from "react";

interface ISVGLayerStackIconProps {
  /**
   * additional classname
   */
  // prettier-ignore
  className?: string;
  /**
   * size of the svg icon
   */
  // prettier-ignore
  size?: string | number;
  /**
   * color of the svg icon
   */
  // prettier-ignore
  fill?: string;
  /**
   * onClick event
   */
  // prettier-ignore
  onClick?: React.MouseEventHandler<SVGSVGElement>;
}

const style = {
  display: "block",
  flex: "0 0 auto",
  cursor: "pointer"
};

export default class SVGLayerStackIcon extends PureComponent<
  ISVGLayerStackIconProps,
  {}
> {
  render() {
    const props = this.props;
    const { size, fill } = props;
    return (
      <svg
        {...props}
        preserveAspectRatio="xMidYMid meet"
        fontSize={size || 32}
        fill={fill || "currentColor"}
        style={style}
        x="0px"
        y="0px"
        width="14px"
        //height="14px"
        height="20px"
        viewBox="0 0 35 35"
        enableBackground="new 0 0 35 35"
      >
        <path
          fill="#FFFFFF"
          d="M0.849,10.12l15.924,7.223c0.465,0.211,0.99,0.211,1.455,0l15.924-7.223c1.131-0.514,1.131-2.223,0-2.737
	L18.228,0.159c-0.461-0.211-0.992-0.211-1.455,0L0.849,7.382C-0.282,7.895-0.282,9.606,0.849,10.12z M34.153,16.153l-3.973-1.799
	l-11.049,5.007c-0.518,0.234-1.066,0.355-1.631,0.355s-1.113-0.119-1.631-0.355L4.821,14.354l-3.973,1.799
	c-1.131,0.514-1.131,2.222,0,2.734l15.924,7.219c0.465,0.211,0.99,0.211,1.455,0l15.924-7.219
	C35.282,18.375,35.282,16.667,34.153,16.153L34.153,16.153z M34.153,24.889l-3.957-1.793l-11.063,5.016
	c-0.518,0.234-1.066,0.355-1.631,0.355c-0.566,0-1.113-0.119-1.633-0.355L4.808,23.096l-3.957,1.793
	c-1.132,0.514-1.132,2.223,0,2.734l15.922,7.219c0.465,0.211,0.992,0.211,1.455,0l15.926-7.219
	C35.282,27.111,35.282,25.402,34.153,24.889z"
        />
      </svg>
    );
  }
}
